<template>
  <div id="nav">
    <router-link to="/">Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#nav {
  font-family: 'Source Code Pro', monospace;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  position:absolute;
  left:0;
  top:0;
  height: 60px;
  width:100%;
  z-index:200;

  a {
    color: white;
  }
}
</style>
